<script setup lang="ts">
import { useRoute } from 'vue-router'
const route = useRoute()
</script>

<template>
  <div class="main-layout">
    <div class="main-layout-header">
      <LayoutHeader :is-workbench="true" />
    </div>
    <div class="main-layout-content" ref="mainLayoutContent" id="main-layout-content">
      <div style="height: 100%;">
        <slot />
      </div>
      <!-- <LayoutFooter /> -->
    </div>
    <client-only>
      <el-backtop :right="25" :bottom="130" target="#main-layout-content" style="width: 60px;height: 60px;">
        <div class="desktop-backtop-icon">
          <i class="iconfont icon-icon_icon_to2" />
        </div>
      </el-backtop>
    </client-only>
  </div>
</template>

<style lang="less" scoped>
.main-layout {
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100vh;
  .main-layout-header {
    width: 100%;
    position: sticky;
    top: 0;
    z-index: 100;
  }
  .main-layout-content {
    flex: 1;
    overflow-y: auto;
    width: 100%;
    min-height: 400px;
    display: flex;
    flex-direction: column;
  }
  .desktop-container-wrapper {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
  }
}
</style>
